import React, { useCallback, useMemo } from "react";
import { updateGenerativeTrigger } from "../../../../../services/generative-triggers";
import { TriggerModal } from "../Form";

const TriggerEdit = (props) => {
    const update = useCallback((assistant, values) => {
        return updateGenerativeTrigger(props.initValues.id, assistant, values);
    }, [])

    const initValues = useMemo(() => {
        const source = props.initValues;

        if (!source?.args?.parameters?.properties) return source;

        const properties = Object.keys(source.args.parameters.properties).map((name) => ({
            name,
            ...source.args.parameters.properties[name],
            required: source.args.parameters.required?.includes(name) ?? false,
            limitOptions: (source.args.parameters.properties[name]?.enum?.length ?? 0) > 0,
        }));

        return {
            ...source,
            args: {
                ...source.args,
                parameters: {
                    ...source.args.parameters,
                    properties,
                },
            },
        };
    }, [props.initValues]);

    return <TriggerModal onFinish={update} okText={'Salvar'} {...props} initValues={initValues} />
}

export default TriggerEdit;
